// src/pages/HomePage.js
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { normalizeRole, ROLE_VALUE } from "../constants/roleLabels";
import HeroSection from "../components/homepage/HeroSection";
import FeatureSection from "../components/homepage/FeatureSection";
import BenefitsSection from "../components/homepage/BenefitsSection";
import HomeFooter from "../components/homepage/HomeFooter";
import RegionNotice from "../components/RegionNotice";
import { logger } from "../utils/logger";

function HomePage() {
  const { currentUser, currentUserRole, ready } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logger.log("🏠 HomePage rendered");
    logger.log("🔑 currentUser =", currentUser);
    logger.log("📦 currentUserRole =", currentUserRole);
    logger.log("✅ ready =", ready);

    if (ready && currentUser) {
      const role = normalizeRole(currentUserRole);
      const target =
        role === ROLE_VALUE.specialist ? "/dashboard-helper" : "/dashboard-client";
      navigate(target, { replace: true });
    }
  }, [currentUser, currentUserRole, ready, navigate]);

  if (!ready || currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <RegionNotice />

      {/* Hero Section */}
      <HeroSection />

      {/* How It Works & Intelligence Matching */}
      <FeatureSection />

      {/* For Requesters & Specialists */}
      <BenefitsSection />


      {/* Final dark CTA banner */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            Your checkout is broken right now.
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
            Every minute costs you money. Get an expert on screen in under 2 hours.
          </p>
          <div className="flex justify-center mb-6">
            <Link
              to="/submit-problem"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-blue-600 text-white font-bold text-lg rounded-xl hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl"
            >
              Fix It Now — from €149
            </Link>
          </div>
          <p className="text-sm text-slate-400">
            Serving Europe · Available Mon–Sat, 07:00–23:00 CET
          </p>
        </div>
      </section>

      {/* Footer */}
      <HomeFooter />
    </div>
  );
}

export default HomePage;
